import React, { forwardRef } from "react";
import { BSDiv } from "../../types";

export const DropdownDivider = forwardRef<HTMLDivElement, BSDiv>(
  ({ children, ...props }, ref) => (
    <div {...props} className="dropdown-divider" ref={ref}>
      {children}
    </div>
  )
);